// @ts-nocheck
/* ============================================================
   Fence Works — install-day weather (open-meteo, free, no key).
   forecast(lat,lng) → { "YYYY-MM-DD": { rain %, lo °F, hi °F } } for
   the next 16 days, cached per ~1km location for the session.
   risk(day) grades a day for fence work: rain ruins concrete pours,
   deep frost stops digging. Exposed as window.VFP_WEATHER — same
   self-register pattern as lib/parcel.ts / lib/buildings.ts.
   ============================================================ */
import { weatherRisk } from "./weatherrules";   // the grade per service: rain and frost for a fence day; a dry slab, 40°F and the dew point for a coating
(function () {
  "use strict";
  const cache = new Map();
  function forecast(lat, lng) {
    if (lat == null || lng == null) return Promise.resolve(null);
    const key = (+lat).toFixed(2) + "," + (+lng).toFixed(2);
    if (cache.has(key)) return cache.get(key);
    const url = "https://api.open-meteo.com/v1/forecast?latitude=" + lat + "&longitude=" + lng
      + "&daily=precipitation_probability_max,temperature_2m_min,temperature_2m_max,dew_point_2m_mean&temperature_unit=fahrenheit&forecast_days=16&timezone=auto";
    const p = fetch(url).then((r) => (r.ok ? r.json() : null)).then((j) => {
      const d = j && j.daily;
      if (!d || !Array.isArray(d.time)) return null;
      const out = {};
      d.time.forEach((t, i) => {
        out[t] = {
          rain: Number(d.precipitation_probability_max && d.precipitation_probability_max[i]) || 0,
          lo: Number(d.temperature_2m_min && d.temperature_2m_min[i]),
          hi: Number(d.temperature_2m_max && d.temperature_2m_max[i]),
          dew: Number(d.dew_point_2m_mean && d.dew_point_2m_mean[i]),
        };
      });
      return out;
    }).catch(() => { cache.delete(key); return null; });   // transient failure → retry next ask
    cache.set(key, p);
    return p;
  }
  // grade a forecast day: for fence installs as always; for a concrete job
  // (opts = { vertical: "concrete", jobTypes, cfg }) by lib/weatherrules.ts
  function risk(day, opts) {
    return weatherRisk(day, opts);
  }
  window.VFP_WEATHER = { forecast, risk };
})();
